import { apiFetch } from './api.js';

export const apiGet = (url, opts = {}) => apiFetch(url, { ...opts, method: 'GET' });
export const apiPost = (url, body, opts = {}) => apiFetch(url, { ...opts, method: 'POST', body });
export const apiPut = (url, body, opts = {}) => apiFetch(url, { ...opts, method: 'PUT', body });
export const apiDelete = (url, opts = {}) => apiFetch(url, { ...opts, method: 'DELETE' });
